module.exports = __webpack_public_path__ + "media/falabella.9d39981e.mp4";